import { useSessionTypeEditor } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/session-type-editor-context/SessionTypeEditorContext";
import DropdownToggle from "components/dropdown-toggle/DropdownToggle";
import RequiredAsterisk from "components/required-asterisk";
import messages from "messages";
import { useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { AmplitudePageName } from "utils/amplitude";
import getClasses from "utils/getClasses";
import addToCalendarStyles from "../../../../AddToCalendar.module.scss";
import SessionTypeItem from "./SessionTypeItem";
import styles from "./SessionTypeSelector.module.scss";

interface SessionTypeSelectorProps {
  sessionTypes: SessionType[];
  sessionType?: SessionType;
  amplitudePageName: AmplitudePageName;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  setSessionType: React.Dispatch<React.SetStateAction<SessionType | undefined>>;
  setSessionTypes: React.Dispatch<React.SetStateAction<SessionType[]>>;
  trackClick: (elementName: string) => void;
  disabled?: boolean;
}

const SessionTypeSelector = ({
  sessionTypes,
  sessionType,
  amplitudePageName,
  setIsDirty,
  setSessionType,
  setSessionTypes,
  trackClick,
  disabled = false,
}: SessionTypeSelectorProps) => {
  const { openSessionTypeEditor } = useSessionTypeEditor();

  const dropdownToggleTitle = useMemo(() => {
    if (sessionTypes.length === 0) {
      return messages.noSessionTypeAvailable;
    }

    if (!sessionType) {
      return messages.selectASessionType;
    }

    return <SessionTypeItem sessionType={sessionType} />;
  }, [sessionType, sessionTypes.length]);

  return (
    <label className={addToCalendarStyles["label"]}>
      <span className={addToCalendarStyles["label-text"]}>
        {messages.sessiontype}
        <RequiredAsterisk />
      </span>

      <DropdownToggle
        className={getClasses(
          styles["dropdown"],
          sessionTypes.length === 0 || !sessionType?.label
            ? styles["dropdown--empty"]
            : styles["dropdown--selected"],
        )}
        title={dropdownToggleTitle}
        disabled={disabled || sessionTypes.length === 0}
      >
        {sessionTypes.map((sessionType) => (
          <Dropdown.Item
            key={sessionType.label}
            onClick={() => {
              trackClick("dropdown-item");
              setIsDirty(true);
              setSessionType(sessionType);
            }}
          >
            <SessionTypeItem sessionType={sessionType} />
          </Dropdown.Item>
        ))}
        <Dropdown.Item
          className={getClasses(styles["item"], styles["item--primary"])}
          onClick={() => {
            trackClick("add-new-session-type-dropdown-item");
            openSessionTypeEditor(
              {
                // check label duplicated
                getIsLabelInvalid: (arg: string | undefined) =>
                  !arg ? false : sessionTypes.some((el) => el.label === arg),

                onApply: (nextV: SessionType) => {
                  setSessionTypes((s) => [...s, nextV]);
                  // auto select the session type created
                  setSessionType(nextV);
                },
              },
              amplitudePageName,
            );
          }}
        >
          {messages["+addNewSessionType"]}
        </Dropdown.Item>
      </DropdownToggle>
    </label>
  );
};

export default SessionTypeSelector;
